/* eslint-disable */

'use client';

import cn from 'classnames';
import he from 'he';
import Link from 'next/link';

import type { Locale } from '@shared/libs';
import { Button, ButtonColor, Input, Int2, unbounded } from '@shared/ui';

import styles from './recovery-redirect.module.css';
import { useCallback, useState } from 'react';
import { useSetPasswordMutation } from '@shared/api';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';

type TProps = {
  USER_CHECKWORD: string;
  USER_LOGIN: string;
  locale: Locale;
};

type Reset = {
  new_password: string;
  new_password2: string;
};

export const RecoveryRedirect = ({ locale, USER_CHECKWORD, USER_LOGIN }: TProps) => {
  const [errorUnique, setErrorUnique] = useState(false);

  const { register, handleSubmit } = useForm<Reset>();

  const router = useRouter();

  const { mutate, isError, isSuccess, error, isLoading } = useSetPasswordMutation();

  const submit = useCallback(
    ({ new_password, new_password2 }: Reset) => {
      if (new_password === new_password2) {
        mutate({ new_password, USER_CHECKWORD, USER_LOGIN });
        setErrorUnique(false);
      } else {
        setErrorUnique(true);
      }
    },
    [mutate],
  );

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <p className={cn(styles.title, unbounded.className)}>
          {he.decode(locale.PAGE_RECOVERY_PAGE_H1 || 'PAGE_RECOVERY_PAGE_H1')}
        </p>

        <form className={styles.form} onSubmit={handleSubmit(submit)}>
          {isSuccess ? (
            <Int2 className={styles.text}>
              {locale.PAGE_RECOVERY_PAGE_SUCCES || 'PAGE_RECOVERY_PAGE_SUCCES'}
            </Int2>
          ) : (
            <>
              <Input
                placeholder={locale.PAGE_RECOVERY_PAGE_NEW_PASS}
                label={locale.PAGE_RECOVERY_PAGE_NEW_PASS || 'PAGE_RECOVERY_PAGE_NEW_PASS'}
                type="password"
                formGroupClassName={styles.formGroup}
                className={styles.input}
                autocomplete="off"
                {...register('new_password', { required: true })}
              />
              <Input
                placeholder={locale.PAGE_RECOVERY_PAGE_NEW_PASS_2}
                label={locale.PAGE_RECOVERY_PAGE_NEW_PASS_2 || 'PAGE_RECOVERY_PAGE_NEW_PASS_2'}
                type="password"
                autocomplete="off"
                className={styles.input}
                {...register('new_password2', { required: true })}
              />

              {isError && (
                <Int2 className={styles.error}>
                  {error?.response?.data?.error?.msg ||
                    locale.PAGE_RECOVERY_PAGE_ERROR ||
                    'PAGE_RECOVERY_PAGE_ERROR'}
                </Int2>
              )}

              {errorUnique && (
                <Int2 className={styles.error}>
                  {locale.PAGE_PERSONAL_REGISTRATION_PASS_ERROR ||
                    'PAGE_PERSONAL_REGISTRATION_PASS_ERROR'}
                </Int2>
              )}
            </>
          )}

          {isSuccess ? (
            <Button
              type="button"
              onClick={() => router.push('/')}
              color={ButtonColor.GREEN}
              className={styles.btn}
            >
              {locale.PAGE_RECOVERY_PAGE_SUCCES_OK || 'PAGE_RECOVERY_PAGE_SUCCES_OK'}
            </Button>
          ) : (
            <Button
              type="submit"
              color={ButtonColor.GREEN}
              className={styles.btn}
              loading={isLoading}
            >
              {locale.PAGE_RECOVERY_PAGE_BTN || 'PAGE_RECOVERY_PAGE_BTN'}
            </Button>
          )}
        </form>

        <div className={styles.linkWrap}>
          <Link href="/" className={styles.link} prefetch={false}>
            {locale.PAGE_RECOVERY_PAGE_HOME || 'PAGE_RECOVERY_PAGE_HOME'}
          </Link>
        </div>
      </div>
    </div>
  );
};
